
import { Component, Vue, Prop, Emit } from 'vue-property-decorator';
import InputRadio from '@/components/InputRadio.vue';

@Component({
  components: {
    InputRadio
  }
})
export default class TopContentSelect extends Vue {
  @Prop({ type: Array, required: true })
  public list!: {
    key: string;
    page: number;
    text1: string;
    text2: string;
    text3: string;
    srcset: string[] | null;
  }[];

  @Prop({ type: String, required: true })
  public value!: string;

  @Emit()
  public input(value: string) {}

  private imageSrc(srcset: string[] | null): string {
    if (srcset === null) return '';
    return srcset[0];
  }

  private imageSrcset(srcset: string[] | null): string {
    if (srcset === null) return '';
    return srcset
      .map((src: string, index: number): string => src && `${src} ${index + 1}x`)
      .filter((src: string): boolean => !!src)
      .join(',');
  }
}
